/* global axios */

import ApiClient from './ApiClient';

class ShiftManagement extends ApiClient {
  constructor() {
    super('shift_management', { accountScoped: true });
  }

  getDashboard(date) {
    return axios.get(this.url, { params: { date } });
  }

  createTemplate(template) {
    return axios.post(`${this.url}/templates`, { template });
  }

  updateTemplate(id, template) {
    return axios.patch(`${this.url}/templates/${id}`, { template });
  }

  deleteTemplate(id) {
    return axios.delete(`${this.url}/templates/${id}`);
  }

  saveSchedule(userId, date, schedule) {
    return axios.put(`${this.url}/schedules/${userId}`, { date, schedule });
  }

  saveSchedules(date, schedules) {
    return axios.put(`${this.url}/schedules`, { date, schedules });
  }

  startSelfSchedule(date, templateId) {
    return axios.post(`${this.url}/self_schedule`, {
      date,
      template_id: templateId,
    });
  }

  setPresence(userId, date, presence) {
    return axios.patch(`${this.url}/presence`, {
      user_id: userId,
      date,
      presence,
    });
  }

  handover(inboxId, toUserId) {
    return axios.post(`${this.url}/handovers`, {
      inbox_id: inboxId,
      to_user_id: toUserId,
    });
  }

  bulkHandover(handovers) {
    return axios.post(`${this.url}/bulk_handovers`, { handovers });
  }
}

export default new ShiftManagement();
